// Component Imports
import LayoutFooter from '../../../@layouts/components/vertical/Footer';
import { VerticalFooterContent } from './FooterContent';

export const VerticalFooter = () => {
  return (
    <LayoutFooter>
      <VerticalFooterContent />
    </LayoutFooter>
  );
};
